import VEBefore from '@/views/account/assets/images/venhancer-before.png';
import VEAfter from '@/views/account/assets/images/venhancer-after.png';

import PEBefore from '@/views/account/assets/images/penhancer-before.png';
import PEAfter from '@/views/account/assets/images/penhancer-after.png';

import RMBefore from '@/views/account/assets/images/rmvideo-before.png';
import RMAfter from '@/views/account/assets/images/rmvideo-after.png';

import RMttBefore from '@/views/account/assets/images/rmttmark-before.png';
import RMttAfter from '@/views/account/assets/images/rmttmark-after.png';

import RMBgBefore from '@/views/account/assets/images/rmbackground-before.png';
import RMBgAfter from '@/views/account/assets/images/rmbackground-after.png';

import FixOldBefore from '@/views/account/assets/images/fixedold-before.png';
import FixOldAfter from '@/views/account/assets/images/fixedold-after.png';
import { ReactComponent as ConvertIcon } from '@/views/account/assets/icons/convert-icon.svg';
import { ReactComponent as PeIcon } from '@/views/account/assets/icons/pe-icon.svg';
import { ReactComponent as RestoreIcon } from '@/views/account/assets/icons/restore-icon.svg';
import { ReactComponent as TiktokIcon } from '@/views/account/assets/icons/tiktok-icon.svg';
import { ReactComponent as WatermarkIcon } from '@/views/account/assets/icons/watermark-icon.svg';
import { ReactComponent as BgIcon } from '@/views/account/assets/icons/bg-icon.svg';

import i18n from '../../../locales/i18n';
const toolKitArr = [
  {
    productName: i18n.t('upgradePersonal:AIVideoEnhancer'),
    content: i18n.t('upgradePersonal:Enhancer4K'),
    beforeImg: VEBefore,
    afterImag: VEAfter,
    icon: ConvertIcon,
    url: 'https://online.hitpaw.com/toolbox/video/enhance-video-online?source=personalCenter',
    key: 'videoEnhancer',
    btn: i18n.t('upgradePersonal:Enhance'),
    isVip: false,
    nameArr: 'HitPaw Online Video Enhancer',
  },
  {
    productName: i18n.t('upgradePersonal:AIPhotoEnhancer'),
    content: i18n.t('upgradePersonal:AIEnhancerImage'),
    beforeImg: PEBefore,
    afterImag: PEAfter,
    icon: PeIcon,
    url: 'https://online.hitpaw.com/toolbox/image/photo-enhancer?source=personalCenter',
    key: 'photoEnhancer',
    btn: i18n.t('upgradePersonal:Enhance'),
    nameArr: 'HitPaw Online Photo Enhancer',
  },
  {
    productName: i18n.t('upgradePersonal:HitPawWatermark'),
    content: i18n.t('upgradePersonal:rmvContent'),
    beforeImg: RMBefore,
    afterImag: RMAfter,
    icon: WatermarkIcon,
    url: 'https://online.hitpaw.com/toolbox/video/remove-watermark-online?source=personalCenter',
    key: 'videoRemoveWaterMark',
    btn: i18n.t('upgradePersonal:Remove'),
    isVip: false,
    nameArr: 'HitPaw Online Video Watermark Remover',
  },
  {
    productName: i18n.t('upgradePersonal:HitPawRemoveBg'),
    content: i18n.t('upgradePersonal:rmbgContent'),
    beforeImg: RMBgBefore,
    afterImag: RMBgAfter,
    icon: BgIcon,
    url: 'https://online.hitpaw.com/toolbox/image/background-remover?source=personalCenter',
    key: 'backgroundRemover',
    btn: i18n.t('upgradePersonal:Remove'),
    isVip: false,
    nameArr: 'HitPaw Online Background Remover',
  },
  {
    productName: i18n.t('upgradePersonal:HitPawTiktokWatermark'),
    content: i18n.t('upgradePersonal:rmttContent'),
    beforeImg: RMttBefore,
    afterImag: RMttAfter,
    icon: TiktokIcon,
    url: 'https://online.hitpaw.com/toolbox/video/remove-tt-watermark-online?source=personalCenter',
    key: 'removeTTWaterMark',
    btn: i18n.t('upgradePersonal:Remove'),
    isVip: false,
    nameArr: 'HitPaw Online TikTok Watermark Remover',
  },
  {
    productName: i18n.t('upgradePersonal:dynamicTitle'),
    content: i18n.t('upgradePersonal:dynamicContent'),
    beforeImg: FixOldBefore,
    afterImag: FixOldAfter,
    icon: RestoreIcon,
    url: 'https://online.hitpaw.com/animate-old-photos-online.html?linksource=personalCenter',
    key: 'dynamicPhoto',
    btn: i18n.t('upgradePersonal:Animate'),
    isVip: false,
    nameArr: ['HitPaw Online Animate Old Photos', 'HitPaw Online'],
  },
];

export default toolKitArr;
